import { Box, Container, Typography } from '@mui/material';
import { EulaContent } from '../components/Eula/EulaContent';

function EndUserLicenseAgreement() {
  return (
    <>
      <Box
        sx={{
          background: 'linear-gradient(94deg, #1b437f -21.51%, #021635 101.1%)',
          padding: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box>
          <Typography
            variant='h4'
            sx={{
              color: '#fff',
              fontWeight: 600,
              position: 'relative',
              zIndex: 2,
              '&::before': {
                content: '"End User License Agreement"',
                position: 'absolute',
                top: '50%',
                left: '100%',
                transform: 'translate(-50%, -50%) scale(1.1)',
                fontSize: '56px',
                color: 'rgba(255, 255, 255, 0.05)',
                zIndex: 1,
                whiteSpace: 'nowrap',
              },
            }}
          >
            End User License Agreement
          </Typography>
        </Box>
      </Box>
      <Container sx={{ mt: 10, mb: 10 }}>
        <EulaContent showTableOfContents />
      </Container>
    </>
  );
}

export default EndUserLicenseAgreement;
